import { QueryClient } from "@tanstack/react-query"

/**
 * This is our global react query client.
 *
 * It keeps the query state between each place we mount React trees in sync, such as from
 * a page (react-rb) or element (core/mount).
 */
export const queryClient = new QueryClient()
